<template>
    <div id="events" class="section">
        <v-container>
            <h2>Upcoming Events</h2>
            <hr>
            <p class="text-xs-center mb-5">Schedule & announcements</p>   
              <v-layout row wrap>
                 <v-flex xs12 sm3>
                   <div class="img-thumbnail">
                    <a href="https://www.amazon.co.uk/Rachmaninov-Songs-Danishvar-Lilian-Akopova/dp/B076FLVGNT" target="_blank">
                          <img class="img-fluid" src="/img/CDBaby4.jpg" alt="Rachmaninov Songs" width="100%" />
                    </a>
                  </div>
                 </v-flex>
                 <v-flex xs12 sm6 px-4>
                      <v-layout row wrap>
                          <v-flex xs12 v-for="(event, index) in events" :key="index">
                              <h3 class="text-uppercase">{{event.title}}</h3>
                                  <p class="time mt-3">{{ event.date }}</p>
                                  <p v-html="event.text"></p>
                                  <p><a :href="event.link_href" target="_blank">{{ event.link_text }}</a></p>
                              <hr>                    
                          </v-flex>
                      </v-layout>
                 </v-flex>
                 <v-flex xs12 sm3>
                    <div class="img-thumbnail mb-1">
                        <a href="https://store.cdbaby.com/cd/mariadanishvar" target="_blank">
                              <img class="img-fluid" src="/img/CDBaby3.jpg" alt="Buy Maria Danishvar Audio CD" width="100%" />
                        </a>                        
                      </div>
                    <div class="img-thumbnail">
                        <a href="http://http://katiataylor.com/" target="_blank">
                              <img class="img-fluid" src="/img/fr-Katia-Taylor.png" alt="Main picture by Katia Taylor" width="100%" />
                        </a>                        
                      </div>
                 </v-flex>
              </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
      name: 'Events',
        data: () => ({
            events: [
                { 
                  title: 'Fabulous duets at Gillfest',
                  date: 'Tue 03 Jul, 2018',
                  text: 'This is Fabulous Duets second duet programme in the Gillingham Festival Maria Danishvar-soprano Arabella Heaton-mezzo-soprano Elaine Korman-piano. ',
                  link_text: 'Please, buy tickets here:',
                  link_href: 'http://www.gillfest.org/tickets-2018.html' 
                },
                { 
                  title: 'Alleluia! Concert of Baroque and Classical period masterpieces at St. Stephen\'s Church, Lansdown, Bath',
                  date: 'Sat 09 Jun, 2018',
                  text: 'Sacred and secular masterpieces by J.S. Bach, Handel, Mozart and others sang by Maria Danishvar and Evelyn Strasburger also featuring Matthew Taylor, violin, Keith Tempest, cello, James Watts, oboe and David Price, piano',
                  link_text: '',
                  link_href: '' 
                },
                { 
                  title: 'Requiem by Giuseppe Verdi 2',
                  date: 'Sat 19 May, 2018',
                  text: 'Performance of Verdi\'s great oratorio at the Holy Trinity church, Frome, at 7.30 Maria  anishvar-soprano Marie Elliott-mezzo-soprano Dominic Bevan-tenor Jeremy White-bass Neil  Moore-conductor',
                  link_text: '',
                  link_href: '' 
                },
                { 
                  title: 'Requiem by Giuseppe Verdi',
                  date: 'Sat 12 May, 2018',
                  text: 'Performance by Bradford-on-Avon Choral Society and Oakfield Choir at the Wiltshitre Music Centre Maria Danishvar-soprano Marie Elliott-mezzo-soprano Steven Swindles-tenor Jeremy White-bass Rupert Bevan-conductor',
                  link_text: '',
                  link_href: '' 
                },
                { 
                  title: 'New Music-Following the Caccinis, concert in the Bath Museum of Architecture',
                  date: 'Thu 12 Apr, 2018',
                  text: 'Music to delight your senses... a selection of masterpieces by Monteverdi, the Caccinis, Frescobaldi and Barbara Strozzi Maria Danishvar-soprano Din Ghani-lutes, baroque guitar',
                  link_text: 'More info here',
                  link_href: 'http://museumofbatharchitecture.org.uk/event/new-music-following-caccinis/' 
                },
                { 
                  title: 'The golden days of my spring',
                  date: 'Tue 20 Mar, 2018',
                  text: 'Selected songs by Sergey Rachmaninov, at Holburne Museum, Bath, 12.45pm Celebration of Rachmaninov\'s Birthday Maria Danishvar-soprano, Vera Kovaleva-piano',
                  link_text: 'More info here',
                  link_href: 'http://www.holburne.org/events/the-golden-days-of-my-spring/' 
                },
                { 
                  title: 'Laudamus Te',
                  date: 'Sat 03 Feb, 2018',
                  text: 'Concert of sacred and secular music at St. Luke\'s Church in Hatfield Rd at 7.30 Maria Danishvar and Evelyn Strasburger, Sopranos Matt Taylor, violin Keith Tempest, cello, James Watts, oboe David Price, piano',
                  link_text: '',
                  link_href: '' 
                }                                                                               
            ]
        })
    }
</script>

<style>
  #events p.time {
       font-weight: 600;
       font-size: 12px;
   }
  #events a {
     color: #999;
     font-size: 26px;
   }
</style>
